import { css } from 'twin.macro';
import React, { useState, Fragment, useMemo, useEffect } from 'react';

//Helpers
import { SanitizeHTML, isJson } from '../../../_helpers';

//components
import FileMessage from '../Common/FileMessage';
import ChatInput from '../Common/ChatInput';
import ReplyFile from '../Common/ReplyFile';
import SeenByDiv from './SeenByDiv';

//Styles
import { msgContainer } from './styles/MessageStyles';

//icons
import ImagesMessage from '../Common/Messages/ImagesMessage';
import FilesMessage from '../Common/Messages/FilesMessage';
import { FaPhotoVideo } from 'react-icons/fa';
import MessageReactionCounters from '../Message/MessageReactionCounters';
import MessageDetails from '../Message/MessageDetails';
import TextMessageAndSharedLocation from '../Message/TextMessageAndSharedLocation';
import MessageEdited from '../Message/MessageEdited';
import MessageHoverActionContainer from '../Message/MessageHoverOptions/MessageHoverActionContainer';
import { buildReactionCounter } from '../Message/utils/reactionCounter';

const SenderMessage = ({
    rId,
    setReply,
    position,
    refs,
    teamData,
    handleClick,
    handleMessageClick,
    m,
    isForm,
    currUser,
    sendEditedMessage,
    handleDeleteMessage,
    roomType,
    userRole,
    showMessageReactions,
    subChannelId,
    subChannelType,
    roomData,
}) => {
    const {
        id,
        file,
        images,
        files,
        type,
        dateAndTime,
        seenBy,
        isEdited,
        reaction,
        yourReaction,
        visibleTo,
        transcriptions,
    } = m;
    const canDownload = useMemo(() => {
        if (currUser?.role === 'admin') {
            return true;
        } else if (['owner', 'teamManager'].includes(teamData?.role)) {
            return true;
        } else {
            return false;
        }
    }, [currUser, teamData]);
    let messageFile;
    if (file) {
        messageFile = 'file';
    } else if (images && images?.length) {
        messageFile = 'images';
    } else if (files && files?.length) {
        messageFile = 'files';
    }

    const [showActions, setShowActions] = useState(false);
    const [msgEdited, setMsgEdited] = useState(isEdited || false);
    const mData = m.data;
    const [edit, setEdit] = useState('');

    const [reactionCounter, setReactionCounter] = useState(() => {
        if (!reaction) return [];
        return buildReactionCounter(reaction, yourReaction, currUser.name);
    });

    useEffect(() => {
        if (!reaction) {
            setReactionCounter([]);
            return;
        }
        setReactionCounter(buildReactionCounter(reaction, yourReaction, currUser.name));
    }, [reaction, yourReaction, currUser.name]);

    const setReplyMessage = (reply, name) => {
        const teampReply = { ...reply };
        if (teampReply.file || teampReply?.files?.length || teampReply?.images?.length) {
            teampReply.name = name;
            try {
                teampReply.data = teampReply.file || teampReply?.images[0] || teampReply?.files[0];
            } catch (err) {
                teampReply.data = 'shared Files';
            }
            setReply(teampReply);
        } else {
            const { text } = isJson(teampReply.data) ? JSON.parse(teampReply.data) : { text: teampReply.data };
            if (text) {
                teampReply.data = text;
                teampReply.name = name;
                setReply(teampReply);
            }
        }
    };

    let displayMessage, lat, lng, displayReply, displayReplyId, displayReplyUser, replyType;
    try {
        const { text, reply, location } = JSON.parse(mData);
        displayMessage = text;
        if (reply) {
            displayReplyId = reply.id;
            displayReply = reply.reply;
            displayReplyUser = reply.replyUser;
            replyType = reply.type;
        }

        if (location) {
            lat = location.latitude;
            lng = location.longitude;
        }
    } catch (e) {
        displayMessage = mData;
        lat = null;
        lng = null;
    }

    return (
        <Fragment key={id}>
            <div css={msgContainer}>
                <div className="messageContainer justifyEnd">
                    <div className="msg p-2 mt-2 d-flex flex-row align-items-start">
                        <div></div>
                        <div className="px-2">
                            <div
                                className="p-2 pointer d-flex"
                                css={css`
                                    font-size: 14px;
                                `}
                                ref={refs[id]}
                                onClick={() => {
                                    if (isForm) {
                                        handleMessageClick();
                                    }
                                    setShowActions(!showActions);
                                }}
                            >
                                <MessageHoverActionContainer
                                    m={m}
                                    rId={rId}
                                    subChannelId={subChannelId}
                                    roomType={roomType}
                                    subChannelType={subChannelType}
                                    userRole={userRole}
                                    teamData={teamData}
                                    currUser={currUser}
                                    setReplyMessage={setReplyMessage}
                                    setEdit={setEdit}
                                    edit={edit}
                                    handleDeleteMessage={handleDeleteMessage}
                                    isForm={isForm}
                                    roomData={roomData}
                                    //messagereactionselector props
                                    reactionCounter={reactionCounter}
                                    setReactionCounter={setReactionCounter}
                                    //sender message
                                    isSenderMessage={true}
                                />

                                <div className="sent-msg">
                                    {type === 'message' ? (
                                        <div>
                                            {displayReply && (
                                                <div
                                                    className="sent-reply-msg"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleClick(displayReplyId);
                                                    }}
                                                >
                                                    <span className="font-weight-bold">{displayReplyUser}</span>
                                                    {replyType === 'message' ? (
                                                        <div className="d-flex small">
                                                            <SanitizeHTML html={displayReply} />
                                                        </div>
                                                    ) : (
                                                        <div className="d-flex justify-content-end text-justify">
                                                            <ReplyFile file={displayReply} />
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                            {msgEdited ? <div className="edited-label"> Edited</div> : null}

                                            {edit === id ? (
                                                <div
                                                    css={css`
                                                        .message-inputarea {
                                                            .input-features {
                                                                .emojiDrop {
                                                                    .dropdown {
                                                                        a {
                                                                            color: #50aeb0 !important;
                                                                        }
                                                                    }
                                                                }
                                                                > a {
                                                                    color: #50aeb0 !important;
                                                                }
                                                            }
                                                        }
                                                    `}
                                                >
                                                    {subChannelId ? (
                                                        <ChatInput
                                                            messageText={displayMessage}
                                                            key={subChannelId}
                                                            id={subChannelId}
                                                            sendMessage={(e, data) => {
                                                                e.preventDefault();
                                                                const { reply } = JSON.parse(mData);
                                                                if (reply) {
                                                                    sendEditedMessage(
                                                                        reply,
                                                                        data,
                                                                        edit,
                                                                        position,
                                                                        subChannelId,
                                                                        msgEdited,
                                                                        visibleTo
                                                                    );
                                                                    setMsgEdited(true);
                                                                } else {
                                                                    sendEditedMessage(
                                                                        null,
                                                                        data,
                                                                        edit,
                                                                        position,
                                                                        subChannelId,
                                                                        msgEdited,
                                                                        visibleTo
                                                                    );
                                                                    setMsgEdited(true);
                                                                }
                                                                setEdit(false);
                                                            }}
                                                            type="team"
                                                            editMode
                                                        />
                                                    ) : (
                                                        <ChatInput
                                                            messageText={displayMessage}
                                                            key={rId}
                                                            id={rId}
                                                            sendMessage={(e, data) => {
                                                                e.preventDefault();
                                                                const { reply } = JSON.parse(mData);
                                                                if (reply) {
                                                                    sendEditedMessage(
                                                                        reply,
                                                                        data,
                                                                        edit,
                                                                        position,
                                                                        rId,
                                                                        msgEdited,
                                                                        visibleTo
                                                                    );
                                                                    setMsgEdited(true);
                                                                } else {
                                                                    sendEditedMessage(
                                                                        null,
                                                                        data,
                                                                        edit,
                                                                        position,
                                                                        rId,
                                                                        msgEdited,
                                                                        visibleTo
                                                                    );
                                                                    setMsgEdited(true);
                                                                }
                                                                setEdit(false);
                                                            }}
                                                            type="team"
                                                            editMode
                                                        />
                                                    )}
                                                </div>
                                            ) : (
                                                <TextMessageAndSharedLocation
                                                    displayMessage={displayMessage}
                                                    lat={lat}
                                                    lng={lng}
                                                    isSenderMessage={true}
                                                />
                                            )}
                                        </div>
                                    ) : (
                                        <Fragment>
                                            <MessageEdited msgEdited={isEdited} isSenderMessage={true} />

                                            {edit === id ? (
                                                <div
                                                    css={css`
                                                        .message-inputarea {
                                                            .input-features {
                                                                .emojiDrop {
                                                                    .dropdown {
                                                                        a {
                                                                            color: #50aeb0 !important;
                                                                        }
                                                                    }
                                                                }
                                                                > a {
                                                                    color: #50aeb0 !important;
                                                                }
                                                            }
                                                        }
                                                    `}
                                                >
                                                    {subChannelId ? (
                                                        <ChatInput
                                                            messageText={displayMessage}
                                                            key={subChannelId}
                                                            id={subChannelId}
                                                            sendMessage={(e, data) => {
                                                                e.preventDefault();
                                                                const { reply } = JSON.parse(mData);
                                                                if (reply) {
                                                                    sendEditedMessage(
                                                                        reply,
                                                                        data,
                                                                        edit,
                                                                        position,
                                                                        subChannelId,
                                                                        msgEdited,
                                                                        visibleTo
                                                                    );
                                                                    setMsgEdited(true);
                                                                } else {
                                                                    sendEditedMessage(
                                                                        null,
                                                                        data,
                                                                        edit,
                                                                        position,
                                                                        subChannelId,
                                                                        msgEdited,
                                                                        visibleTo
                                                                    );
                                                                    setMsgEdited(true);
                                                                }
                                                                setEdit(false);
                                                            }}
                                                            type="team"
                                                            editMode
                                                        />
                                                    ) : (
                                                        <ChatInput
                                                            messageText={displayMessage}
                                                            key={rId}
                                                            id={rId}
                                                            sendMessage={(e, data) => {
                                                                e.preventDefault();
                                                                const { reply } = JSON.parse(mData);
                                                                if (reply) {
                                                                    sendEditedMessage(
                                                                        reply,
                                                                        data,
                                                                        edit,
                                                                        position,
                                                                        rId,
                                                                        msgEdited,
                                                                        visibleTo
                                                                    );
                                                                    setMsgEdited(true);
                                                                } else {
                                                                    sendEditedMessage(
                                                                        null,
                                                                        data,
                                                                        edit,
                                                                        position,
                                                                        rId,
                                                                        msgEdited,
                                                                        visibleTo
                                                                    );
                                                                    setMsgEdited(true);
                                                                }
                                                                setEdit(false);
                                                            }}
                                                            type="team"
                                                            editMode
                                                        />
                                                    )}
                                                    <div
                                                        css={css`
                                                            min-width: 350px;
                                                            display: flex;
                                                            align-items: center;
                                                            font-weight: 700;
                                                            padding: 0 2rem;
                                                        `}
                                                    >
                                                        <FaPhotoVideo fontSize="48" />
                                                        <span
                                                            css={css`
                                                                margin-left: 1rem;
                                                            `}
                                                        >
                                                            Shared Media
                                                        </span>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div
                                                    className="d-flex justify-content-end text-justify flex-column"
                                                    css={css`
                                                        padding: 0.5rem;
                                                        .pdftext,
                                                        .fileName {
                                                            color: white !important;
                                                        }
                                                    `}
                                                >
                                                    {messageFile === 'file' ? (
                                                        <FileMessage
                                                            file={file}
                                                            displayMessage={displayMessage}
                                                            css={css`
                                                                color: white !important;
                                                            `}
                                                            from="current-user"
                                                            documentSettings={canDownload}
                                                        />
                                                    ) : messageFile === 'images' ? (
                                                        <ImagesMessage
                                                            images={images}
                                                            displayMessage={displayMessage}
                                                            css={css`
                                                                color: white !important;
                                                            `}
                                                            from="current-user"
                                                            teamDetails={canDownload}
                                                            transcriptions={transcriptions}
                                                        />
                                                    ) : messageFile === 'files' ? (
                                                        <FilesMessage
                                                            files={files}
                                                            displayMessage={displayMessage}
                                                            css={css`
                                                                color: white !important;
                                                            `}
                                                            from="current-user"
                                                            canDownload={canDownload}
                                                        />
                                                    ) : null}
                                                </div>
                                            )}
                                        </Fragment>
                                    )}
                                </div>
                            </div>
                            <MessageReactionCounters
                                id={id}
                                reactionCounter={reactionCounter}
                                currUser={currUser}
                                showMessageReactions={showMessageReactions}
                                isSenderMessage={true}
                            />
                            <MessageDetails
                                showActions={showActions}
                                lat={lat}
                                lng={lng}
                                dateAndTime={dateAndTime}
                                isSenderMessage={true}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {seenBy?.length > 0 && <SeenByDiv seenBy={seenBy} messageType="self" />}
        </Fragment>
    );
};
export default SenderMessage;
